import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Register from '../pages/Register';
import Mentions from '../pages/Mentions';
import AuthVerify from '../pages/AuthVerify';
import AccountPreferences from '../pages/AccountPreferences';
import MonitoredIdentities from '../pages/MonitoredIdentities';
import EmailConfirmed from '../pages/EmailConfirmed';
import EmailConfirmation from '../pages/EmailConfirmation';
import Unsubscribe from '../pages/Unsubscribe';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import LegalDisclaimer from '../pages/LegalDisclaimer';
import FAQ from '../pages/FAQ';
import WhyMonitoringMatters from '../pages/WhyMonitoringMatters';
import OurCommitment from '../pages/OurCommitment';
import HowItWorks from '../pages/HowItWorks';
import PrivateRoute from './PrivateRoute';

// Emergency router that works without i18n translations
// Uses default Spanish routes only
export default function FallbackRouter() {
  return (
    <Routes>
      {/* Public routes - Spanish only as fallback */}
      <Route path="/" element={<Home />} />
      <Route path="/es/" element={<Home />} />
      <Route path="/es/registrarse" element={<Register />} />
      <Route path="/es/auth/verify" element={<AuthVerify />} />
      <Route path="/es/confirmar-email" element={<EmailConfirmation />} />
      <Route path="/es/email-confirmado" element={<EmailConfirmed />} />
      <Route path="/es/confirmar-email/:token" element={<EmailConfirmation />} />
      <Route path="/es/darse-de-baja/:token" element={<Unsubscribe />} />
      <Route path="/es/politica-de-privacidad" element={<PrivacyPolicy />} />
      <Route path="/es/aviso-legal" element={<LegalDisclaimer />} />
      <Route path="/es/preguntas-frecuentes" element={<FAQ />} />
      <Route path="/es/por-que-monitorear-importa" element={<WhyMonitoringMatters />} />
      <Route path="/es/nuestro-compromiso" element={<OurCommitment />} />
      <Route path="/es/como-funciona" element={<HowItWorks />} />

      {/* Protected routes - Spanish only as fallback */}
      <Route path="/es/menciones" element={
        <PrivateRoute>
          <Mentions />
        </PrivateRoute>
      } />
      <Route path="/es/preferencias-de-cuenta" element={
        <PrivateRoute>
          <AccountPreferences />
        </PrivateRoute>
      } />
      <Route path="/es/identidades-monitoreadas" element={
        <PrivateRoute>
          <MonitoredIdentities />
        </PrivateRoute>
      } />

      {/* Redirect all other paths to Spanish home */}
      <Route path="*" element={<Navigate to="/es/" replace />} />
    </Routes>
  );
}